var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperHappyFaceBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 271,
    viewBox: "0 0 271 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.695 162C185.643 188.025 163.042 208 135.876 208C108.653 208 86.1092 188.025 82 162C100.834 162 118.012 162 137.931 162C157.792 162 174.171 162 189.695 162Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8942 87.3029C93.2328 83.3869 104.76 88.6082 108.681 98.8136C112.603 109.138 107.493 120.767 97.1543 124.683C86.8158 128.599 75.289 123.496 71.3675 113.172C67.3271 102.848 72.5557 91.3376 82.8942 87.3029Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.894 87.3029C180.233 83.3869 191.76 88.6082 195.681 98.8136C199.603 109.138 194.493 120.767 184.154 124.683C173.816 128.599 162.289 123.496 158.367 113.172C154.327 102.848 159.556 91.3376 169.894 87.3029Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 135.5,
    r: 128,
    stroke: "black",
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperHappyFaceBorder);
export default __webpack_public_path__ + "static/media/super-happy-face-border.eda806f6880928e537713d17ad7f3a96.svg";
export { ForwardRef as ReactComponent };